define( function() {
	return ( /^\s+/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rleadingWhitespace.js
// module id = 342
// module chunks = 1